import alertsFactory from "../alerts";

export default {
	teamingPackage: "",
	computed: {
		$alert() {
			const { name, teamingPackage, } = this.$options;
			if ( !teamingPackage ) {
				// eslint-disable-next-line no-console
				return console.error( `cannot create alert factory for component ${ name }: missing teamingPackage property` );
			}
			return alertsFactory( `${ teamingPackage }.components.${ name }`, this.$t );
		},
	},
	methods: {
		alertSuccess( key, args = {}, options = {} ) {
			return this.$alert.success( key, args, options );
		},
		alertInfo( key, args = {}, options = {} ) {
			return this.$alert.info( key, args, options );
		},
		alertWarn( key, args = {}, options = {} ) {
			return this.$alert.warn( key, args, options );
		},
		alertError( key, args = {}, options = {}, logToConsole = true ) {
			return this.$alert.error( key, args, options, logToConsole );
		},
		alertClean( options = { group: "", } ) {
			return this.$alert.clean( options );
		},
	},
};
